import { Link } from "react-router-dom";
import { FaHome } from "react-icons/fa";
import { motion } from "framer-motion";

const ServicesBanner = () => {
  return (
    <section
      className="relative pt-32 md:pt-40 pb-16 md:pb-28 overflow-hidden"
      style={{
        backgroundImage:
          "linear-gradient(135deg, rgba(8,43,87,0.97) 0%, rgba(8,43,87,0.88) 50%, rgba(8,43,87,0.97) 100%), url('/images/services-banner.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Glowing Accents */}
      <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-[#F59E0B]/5 rounded-full blur-[120px] pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-[300px] h-[300px] bg-sky-500/5 rounded-full blur-[100px] pointer-events-none" />

      <div className="container-custom text-center max-w-4xl mx-auto relative z-10">
        {/* Breadcrumb Capsule */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="inline-flex items-center gap-3 bg-white/5 border border-white/10 backdrop-blur-md px-5 py-2.5 rounded-full text-sm text-white/90 shadow-sm mb-8 transition hover:border-[#F59E0B]/30 hover:bg-white/10"
        >
          <Link to="/" className="flex items-center gap-2 hover:text-[#F59E0B] transition-colors duration-300">
            <FaHome />
            Home
          </Link>
          <span className="opacity-40">/</span>
          <span className="text-[#F59E0B] font-medium">Services</span>
        </motion.div>

        {/* Heading */}
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.25 }}
          className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-white leading-tight tracking-tight heading-font"
        >
          Our
          <span className="text-[#F59E0B]"> Services</span>
        </motion.h1>

        {/* Subtitle */}
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="text-white/80 mt-6 max-w-3xl mx-auto text-base md:text-lg leading-8"
        >
          Comprehensive construction, development, property consultancy and liaisoning solutions tailored to your needs.
        </motion.p>
      </div>
    </section>
  );
};

export default ServicesBanner;